const apiKey = "AIzaSyDzT4XDk8pX8nI3FRSHKYvQe9kMobQgxNI";

export const googleTranslate = require("google-translate")(apiKey);